import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader } from "@/components/shared/loader";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useUpdateSettings } from "@/features/settings/hooks/useSettingsMutations";
import {
  platformSettingsValidation,
  type PlatformSettingsFormValues,
} from "@/validations/settings";
import type { PlatformSettings } from "@/types/settings";

interface PlatformSettingsFormProps {
  platform?: PlatformSettings;
}

export function PlatformSettingsForm({ platform }: PlatformSettingsFormProps) {
  const updateMutation = useUpdateSettings();

  const formMethods = useForm<PlatformSettingsFormValues>({
    values: {
      siteName: platform?.siteName ?? "",
      supportEmail: platform?.supportEmail ?? "",
    },
    resolver: zodResolver(platformSettingsValidation),
  });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = formMethods;

  const isPending = isSubmitting || updateMutation.isPending;

  async function onSubmit(data: PlatformSettingsFormValues) {
    await updateMutation.mutateAsync({ platform: data });
  }

  return (
    <Form {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={control}
          name="siteName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>اسم الموقع</FormLabel>
              <FormControl>
                <Input placeholder="وزارة المالية" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="supportEmail"
          render={({ field }) => (
            <FormItem>
              <FormLabel>بريد الدعم الفني</FormLabel>
              <FormControl>
                <Input
                  type="email"
                  placeholder="support@mof.gov.iq"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit" disabled={isPending}>
          حفظ إعدادات المنصة
          {isPending && <Loader className="mr-2" />}
        </Button>
      </form>
    </Form>
  );
}
